import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import "../../styles/AdminDashboard.css";

function NavBar({ fullName }) {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  // ── Sign out the admin ─────────────────────────────────────────
  const handleSignOut = async () => {
    await signOut();
    navigate("/admin", { replace: true });
  };

  return (
    <header className="adminDash__header">
      <div className="adminDash__headerInner">
        <div className="adminDash__brand">
          <div className="adminDash__brandDot" />
          <span className="adminDash__brandName">C4SEAS Admin</span>
        </div>

        <div className="adminDash__headerRight">
          {/* Show the admin's name if we have it */}
          <span className="adminDash__adminName">{fullName}</span>

          <button className="adminDash__signOut" onClick={handleSignOut} type="button">
            Sign out
          </button>
        </div>
      </div>
    </header>
  );
}

export default NavBar;
